export default __webpack_public_path__ + "static/media/walt-disney.b1058246.png";